import React from 'react';
import { connect } from 'react-redux';
import geofences from 'APP_ROOT/data/geofences';
import ProgressSpinnerSmall from 'APP_ROOT/components/common/ProgressSpinnerSmall';

import { strings } from 'APP_ROOT/localization';

export class Notifications extends React.Component {

    onEnterChange = () => {
        const toggledEnterValue = this.props.value && this.props.value.enter ? !this.props.value.enter : true;
        const exitValue = this.props.value && this.props.value.exit ? this.props.value.exit : false;
        this.props.onChange({
            enter: toggledEnterValue,
            exit: exitValue
        });
    }

    onExitChange = () => {
        const toggledExitValue = this.props.value && this.props.value.exit ? !this.props.value.exit : true;
        const enterValue = this.props.value && this.props.value.enter ? this.props.value.enter : false;
        this.props.onChange({
            enter: enterValue,
            exit: toggledExitValue
        });
    }

    render () {
        return (
            <section className="notification">
                <h4 className="label">{strings.resource_notification}</h4>
                <div className="value">
                    {this.props.status === "PENDING" ?
                        <div className={"status-overlay"}>
                            <ProgressSpinnerSmall />
                        </div>
                        :
                        null
                    }
                    <button onClick={this.onEnterChange} disabled={!this.props.editable}>
                        {this.props.value && this.props.value.enter ?
                            <i className="material-icons checked">check_box</i> :
                            <i className="material-icons unchecked">check_box_outline_blank</i>
                        }
                        <span>{strings.geofence_notification_on_enter}</span>
                    </button>
                    <button onClick={this.onExitChange} disabled={!this.props.editable}>
                        {this.props.value && this.props.value.exit ?
                            <i className="material-icons checked">check_box</i> :
                            <i className="material-icons unchecked">check_box_outline_blank</i>
                        }
                        <span>{strings.geofence_notification_on_exit}</span>
                    </button>
                </div>
            </section>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        value: geofences.Selectors.geofenceNotification(state, ownProps.geofenceId),
        status: geofences.Selectors.geofenceNotificationChangePending(state, ownProps.geofenceId) ? 'PENDING' : '',
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onChange: (notification) => dispatch(
            geofences.Actions.setGeofenceNotification(ownProps.stage, ownProps.geofenceId, notification)
        ),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
